import axios from 'axios';

export const api = axios.create({
    baseURL: "https://icvcalc-backend.cnpma.embrapa.br/",
    //baseURL:"http://localhost:8080",
});

api.interceptors.request.use(
  (config) => {
    const user = localStorage.getItem('user');
    if (user) {
      try {
        const userObj = JSON.parse(user);
        if (userObj.token_api) {
            config.headers.Authorization = `Bearer ${userObj.token_api}`;
        }
      } catch (error) {
        console.error('Erro ao fazer parse do user no localStorage', error);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;